/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SchemaDefinitionDto
 */
export interface SchemaDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionDto
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionDto
     */
    purpose?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionDto
     */
    version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SchemaDefinitionDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionDto
     */
    scope?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SchemaDefinitionDto
     */
    schema?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SchemaDefinitionDto
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the SchemaDefinitionDto interface.
 */
export function instanceOfSchemaDefinitionDto(value: object): value is SchemaDefinitionDto {
    return true;
}

export function SchemaDefinitionDtoFromJSON(json: any): SchemaDefinitionDto {
    return SchemaDefinitionDtoFromJSONTyped(json, false);
}

export function SchemaDefinitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchemaDefinitionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'] == null ? undefined : json['slug'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'version': json['version'] == null ? undefined : json['version'],
        'active': json['active'] == null ? undefined : json['active'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'schema': json['schema'] == null ? undefined : json['schema'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function SchemaDefinitionDtoToJSON(json: any): SchemaDefinitionDto {
    return SchemaDefinitionDtoToJSONTyped(json, false);
}

export function SchemaDefinitionDtoToJSONTyped(value?: SchemaDefinitionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
        'title': value['title'],
        'description': value['description'],
        'purpose': value['purpose'],
        'version': value['version'],
        'active': value['active'],
        'scope': value['scope'],
        'schema': value['schema'],
        'metadata': value['metadata'],
    };
}

